import StationsMap from "./StationsMap";

function StationMap({station, height = "600px"}) {
    return (
        <StationsMap stations={[station]} center={[ station.lat, station.long ]} zoom={12} height={height}/>
    )
}

export default StationMap;
